<template>
  <b-container fluid class="p-0 m-0 w-100 h-100">
    <top-menu></top-menu>

    <b-row class="no-gutters h-100">
      <b-col lg="10" md="9" sm="12">
        <dashboard-content></dashboard-content>
      </b-col>
      <b-col lg="2" md="3" sm="12">
        <side-menu :menus="menus"></side-menu>
      </b-col>
    </b-row>
    
  </b-container>
</template>

<script>
import DashboardContent from "./Content.vue"
import TopMenu from "../components/TopMenu"
import SideMenu from "../components/SideMenu"

export default {
  name: 'DashboardLayout',
  components: {
    DashboardContent,
    TopMenu,
    SideMenu
  },
  data: () => ({
    sidemenuActiveIndex: 0,
    menus: [
      {
        title: "داشبورد",
        to: "/dashboard",
        key: "dashboard"
      },
      {
        title: "مدیریت کاربران",
        to: "/users",
        key: "users"
      },
      {
        title: "مدیریت مستندات",
        to: "/documents",
        key: "documents"
      },
      {
        title: "مدیریت منابع",
        to: "/references",
        key: "references"
      },
      {
        title: "مدیریت سرفصل ها",
        to: "/topics",
        key: "topics"
      },
      {
        title: "مدیریت کلیدواژه ها",
        to: "/keywords",
        key: "keywords"
      },
      {
        title: "مدیریت سطوح دسترسی",
        to: "/access-levels",
        key: "access-levels"
      }
    ]
  }),
  created() {
    this.sidemenuActiveIndex = String((this.$route.meta && this.$route.meta.menuIndex) ? this.$route.meta.menuIndex : 0)

    const groupMenus = this.$store.state.auth.user.group.menu_items
    for (let i = 0; i < this.menus.length; i++) {
      const menu = this.menus[i]
      if (!groupMenus.includes(menu.key)) {
        this.menus.splice(i, 1)
      }
      if (String(i) == this.sidemenuActiveIndex) {
        this.menus[i].active = true
      } else {
        this.menus[i].active = false
      }
    }
  }
}
</script>